import React from 'react';
import notCandiFound from '../../../assets/notCandiFound.png';
import './NoCandidateApplied.css';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify'; 

export default function NoCandidateApplied() {
    const params = useParams();

    const shareLink = async () => {
        const jobUrl = `https://webapp.kaamvala.com/user/find-job/job-details/${params.id}`;
        
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Kaamvala Job',
                    text: 'Check out this job opportunity:',
                    url: jobUrl,
                });
            } catch (err) {
                copyToClipboard(jobUrl);
            }
        } else {
            copyToClipboard(jobUrl);
        }
    };
    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            toast.success('Link copied!', { autoClose: 2000 });
        } catch (err) {
           
            console.log('Could not copy link');
        }
    };

    return (
        <div className="yetToApply">
            <img src={notCandiFound} alt="No candidates found" />
            <h1>No Application Yet!</h1>
            <p>It seems that no candidates have applied for this job yet.</p>
            <button className='invite_buttons' onClick={shareLink}>
                Invite Candidates
            </button>
        </div>
    );
}